import React  from "react";

class Contact extends React.Component {
  render() {
    return (
      <div id="contact">
        <h1 className="title">Contact</h1>
        <div id="input_form">
          <form>
            <p>
              If you have any comments on this site, please use the form below.
              <br />
              <span>このサイトにコメントなどありましたら以下のフォームからお願い致します。</span>
            </p>
            <div className="name">
              <label>
                Name / お名前
                <span>必須</span>
              </label>
              <br />
              <input
                id="name"
                type="text"
                placeholder="お名前を入力してください。"
                required
              />
            </div>
            <div className="email">
              <label>
                E-mail / メールアドレス
                <span>必須</span>
              </label>
              <br />
              <input
                id="email"
                type="email"
                placeholder="メールアドレスを入力してください。"
                required
              />
            </div>
            <div className="comments">
              <label>
                Comments / コメント
                <span>必須</span>
              </label>
              <br />
              <textarea
                id="comments"
                name="comments"
                rows="10"
                cols="10"
                placeholder="コメントを入力してください。"
                required
              />
            </div>
            <input id="submit" type="submit" value="送信する" />
          </form>
        </div>
      </div>
    );
  }
}

export default Contact;
